const breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

function init_close_on_click() {
  let header_links = document.querySelectorAll("nav .navbar-nav .nav-item a:not(.dropdown-toggle)");
  let menu_breakpoint = document.querySelector(".navbar").getAttribute("menu-breakpoint")
  header_links.forEach((element, index) => {
    element.addEventListener("click", (event) => {
      if (window.innerWidth < breakpoints[menu_breakpoint]) {
        document.querySelector(".navbar-toggler").click();
      }
    });
  });
}

let initialized = false;
(function (Drupal) {
  Drupal.behaviors.navbar_close_after_click_Behaviour = {
    attach: function (context, settings) {
      if (!initialized) {
        initialized = true;
        init_close_on_click();
      }
    },
  };
})(Drupal);
